import type { OgsmStatus } from '@/types/api'

/** The OGSM status picker's order: the moving statuses first, then On Hold and the finished ones. */
export const OGSM_STATUS_OPTIONS: OgsmStatus[] = [
  'ON_TRACK',
  'AT_RISK',
  'OFF_TRACK',
  'ON_HOLD',
  'ACHIEVED',
  'NOT_STARTED',
]
